var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-7xl mx-auto"},[_c('UserDetailsHeader'),_c(_vm.workspaceComponent,{tag:"component"}),_c('SearchPatientsModal'),_c('BookVisitModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }